import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class LocalizerService {
    static loadedTranslations = null;
    static readonly supportedLanguages = ["en", "fr", "es"];
    static navigator: Partial<Navigator> = navigator || { languages: ["en"] };

    static get browserLanguages() {
        return this.navigator?.languages || [this.navigator?.language || ""];
    }

    static get supportedLanguage() {
        // check if language is supported
        for (let lang of this.browserLanguages) {
            // if the language code is too short, return null
            if (lang?.length >= 2) {
                // check if the generic language is supported
                if (this.supportedLanguages.includes(lang)) {
                    return lang;
                }

                const shortenedLang = lang.substring(0, 2);

                if (this.supportedLanguages.includes(shortenedLang)) {
                    return shortenedLang;
                }
            }
        }

        return "en";
    }

    // Add new methods below that will help other services easily retrieve data from the json structure
    static getDeviceCategory(category: string) {
        if (category && this.loadedTranslations?.deviceAdd?.categories?.[category]) {
            return this.loadedTranslations.deviceAdd.categories[category];
        }

        return category;
    }
}
